import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectTrialInfo } from '@/features/billing/redux/trial-selectors';
import { fetchTrialDaysRequest } from '@/features/billing/redux/trial-slice';
import { useAuth } from '@/shared/hooks/useAuth';
import { AppDispatch } from '@/shared/store/store';
import { rutaDePlanes } from '@/features/billing/utils/ruta-de-planes';
import { desplazamientoPorAvisos } from './avisos-superiores';

const TrialExpiredBanner: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useAuth();
  const trialInfo = useSelector(selectTrialInfo);

  // Cargar información del trial al montar
  useEffect(() => {
    if (user && user.role !== 'SUPER_ADMIN') {
      dispatch(fetchTrialDaysRequest());
    }
  }, [dispatch, user]);


  // No mostrar para SUPER_ADMIN
  if (user?.role === 'SUPER_ADMIN') {
    return null;
  }

  // Solo mostrar si el trial estaba habilitado pero ya finalizó
  // Condiciones: trial habilitado, no está en trial activo, y días restantes son 0
  if (!trialInfo.trialEnabled) {
    return null; // No mostrar si el trial no está habilitado
  }
  
  if (trialInfo.isInTrial || trialInfo.daysRemaining > 0) {
    return null; // No mostrar si aún está en trial o tiene días restantes
  }
  
  // Si llegamos aquí, el trial está habilitado pero ha finalizado

  const handleGoToPlans = () => {
    // GH#1679 · 17.3: una sola tabla rol → ruta, compartida con TrialActivatedModal.
    navigate(rutaDePlanes(user?.role));
  };

  return (
    // GH#2318: va debajo del aviso amarillo de modo demo cuando los dos se ven (antes el amarillo lo tapaba).
    // GH#2768: y debajo de la barra de suplantación si también se ve (mismo cálculo que la cabecera, sin aviso de prueba propio).
    <div style={{ top: desplazamientoPorAvisos(false) }} className="fixed left-0 right-0 z-50 h-[40px] bg-red-300 text-red-900 flex items-center justify-center px-4">
      <div className="flex items-center justify-center gap-3 text-sm font-medium w-full max-w-full overflow-hidden">
        <span className="truncate">Tu trial ha finalizado. Para continuar usando los servicios de InboMarket selecciona un plan</span>
        <button
          onClick={handleGoToPlans}
          className="bg-white text-red-700 px-3 py-1.5 rounded-md text-sm font-semibold hover:bg-red-50 transition-colors whitespace-nowrap flex-shrink-0 shadow-sm"
        >
          Ver Planes
        </button>
      </div>
    </div>
  );
};

export default TrialExpiredBanner;

